import { useCallback } from 'react'
import {
  usePostAffiliates,
  useReadyAffiliate,
} from '~/features/shared/affiliate/hooks'
import { ScreenIds } from '~/types/screenIds'

type UseAffiliateTransition = (itemId: number | null) => void

export const useAffiliateTransition: UseAffiliateTransition = (itemId) => {
  const { postAffiliates } = usePostAffiliates()

  const post = useCallback(
    (
      screenId: ScreenIds,
      objectId: number,
      preScreenId: ScreenIds | undefined,
      preObjectId: number
    ) => {
      if (itemId === null) return

      // WEAR1側では「画面再描画は除外する」と書かれていたが、
      // WEAR1の挙動を確認したらリロードするたびにSetAffiliateされていた
      // おそらくwear.affiliate.inc.asp(WEAR2だと/lib/affiliate/init.ts)にobjectIdに0を入れるコードが書かれているため、
      // tmpObjectId !== item.idの判定が毎回trueになるからだと思われる
      // アクセス解析の結果が変わってしまう為、現状はそのままでいく
      if (
        (screenId === ScreenIds.ItemDetail && objectId !== itemId) ||
        screenId !== ScreenIds.ItemDetail
      ) {
        postAffiliates({
          before_screen_id: Number(screenId ?? ScreenIds.Unknown),
          content_id: objectId || 0,
          item_id: itemId,
          action_type: 'transition',
          pre_before_screen_id: preScreenId && Number(preScreenId),
          pre_before_content_id: Number.isFinite(preObjectId)
            ? preObjectId
            : undefined,
        })
      }
    },
    [itemId, postAffiliates]
  )
  useReadyAffiliate(post)
}
